import { Component, computed, inject, Signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { FormsModule } from '@angular/forms';
import { TABS_CONFIG } from './tabs-config.token';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'ui-tabs-layout',
  templateUrl: 'tabs.layout.html',
  styleUrls: ['tabs.layout.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, TranslatePipe]
})
export class TabsLayout {
  public tabsConfig = inject(TABS_CONFIG);

  tabs: Signal<{ name: string; icon: string; main: boolean; label?: string }[]> = computed(
    () => this.tabsConfig
  );
  mainTab = computed(() => this.tabs().find((t) => t.main));
}
